import Vue from 'vue';
import Errors from '../classes/Errors';
import Colcade from 'colcade';
import imagesLoaded from 'imagesloaded';
import { animate } from 'popmotion';
import { gsap } from 'gsap';

Vue.component('more-stories-component', {
    props: {
        stories: {
            type: Array
        }
    },
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return { 
            storiesNumber: 3,
            colcade: null,
            start: 0,
            end: 0,
            allStoriesVisible: false,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.end = this.storiesNumber;

        if(this.end >= this.stories.length) {
            this.allStoriesVisible = true;
            console.log('Hide button!')
        }

        const columnHolder = this.$el.querySelector('.more-stories__container');
        if (columnHolder) {
            this.initColumns();
        }
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        initColumns() {
            imagesLoaded( this.$el.querySelector('.more-stories__container'), ( instance ) => {
                this.colcade = new Colcade('.more-stories__container', {
                    columns: '.more-stories__column',
                    items: '.more-stories__item'
                });
            });
        },

        loadMoreStories() {
            this.start += this.storiesNumber;

            if(this.start < this.stories.length) {
                this.end = this.start + this.storiesNumber
                
                if(this.end > this.stories.length) {
                    this.end = this.stories.length;
                    this.allStoriesVisible = true;
                    console.log('DONE!')
                }
                
                // create new item elements
                var elems = [];
                for ( var i = this.start; i < this.end; i++ ) {
                    var elem = this.getItemElement(i);
                    elems.push( elem );
                }
                imagesLoaded( elems, () => {
                    this.colcade.append( elems )
                });
            } else {
                console.log('no more stories!')
            }
        },
        getItemElement(i) {
            var elem = document.createElement('a');
            elem.href = this.stories[i].url;
            elem.className = 'more-stories__item ';

            if(this.stories[0].image) {
                var divImg = document.createElement('div');
                divImg.className = "more-stories__item__image-holder";
                var img = document.createElement('img');
                img.src = this.stories[i].image;
                img.className = "more-stories__item__image";
                divImg.appendChild( img );
                elem.appendChild( divImg );
            }
            if(this.stories[0].title) {
                var title = document.createElement('h3');
                title.className = 'intro-text';
                title.innerHTML = this.stories[i].title;
                elem.appendChild( title );
            }
            if(this.stories[0].postDate) {
                var postDate = document.createElement('div');
                postDate.className = 'body-title more-stories__item-date';
                postDate.innerHTML = this.stories[i].postDate;
                elem.appendChild( postDate );
            }

            return elem;
        },


        LoadmoreBounceMouseEnter(e) {
            const circle = e.currentTarget.querySelector('.more-stories__load-more__circle');
            const text = e.currentTarget.querySelector('.more-stories__load-more-text');
            const icon = e.currentTarget.querySelector('.load-more-icon');

            const circleAnim = animate({ 
                from: 1,
                to: .85,
                type: "spring",
                stiffness: 800,
                damping: 20,
                onUpdate: (latest) => {
                    gsap.set(circle, {scale: latest});
                }
            })

            const iconScaleAnim = animate({ 
                from: 1,
                to: .85,
                type: "spring",
                stiffness: 800,
                damping: 20,
                onUpdate: (latest) => {
                    gsap.set(icon, {scale: latest});
                }
            })

            const iconTranslateAnim = animate({ 
                from: 0,
                to: 20,
                type: "spring",
                stiffness: 800,
                damping: 20,
                onUpdate: (latest) => {
                    gsap.set(icon, {translateY: latest});
                }
            })

            const textAnim = animate({ 
                from: 1,
                to: 1.15,
                type: "spring",
                stiffness: 800,
                damping: 20,
                onUpdate: (latest) => {
                    gsap.set(text, {scale: latest});
                }
            })
        },
        
        LoadmoreBounceMouseOut(e) {
            const circle = e.currentTarget.querySelector('.more-stories__load-more__circle');
            const text = e.currentTarget.querySelector('.more-stories__load-more-text');
            const icon = e.currentTarget.querySelector('.load-more-icon');

            const circleAnim = animate({ 
                from: .85,
                to: 1,
                type: "spring",
                stiffness: 800,
                damping: 20,
                onUpdate: (latest) => {
                    gsap.set(circle, {scale: latest});
                }
            })

            const iconScaleAnim = animate({ 
                from: .85,
                to: 1,
                type: "spring",
                stiffness: 800,
                damping: 20,
                onUpdate: (latest) => {
                    gsap.set(icon, {scale: latest});
                }
            })

            const iconTranslateAnim = animate({ 
                from: 20,
                to: 0,
                type: "spring",
                stiffness: 800,
                damping: 20,
                onUpdate: (latest) => {
                    gsap.set(icon, {translateY: latest});
                }
            })

            const textAnim = animate({ 
                from: 1.15,
                to: 1,
                type: "spring",
                stiffness: 800,
                damping: 20,
                onUpdate: (latest) => {
                    gsap.set(text, {scale: latest});
                }
            })
        },
        
        
    }
});
